export enum AttendanceType {
  // [Description("Falta")]
  Absence = 0,
  // [Description("Asistencia")]
  Worked = 1,
  // [Description("Día Libre")]
  DayOff = 2,
  // [Description("Vacaciones")]
  Vacation = 3,
  // [Description("Permiso")]
  Permission = 4,
  MedicalLicense = 5,
  // [Description("Turno Extra")]
  ExtraShift = 6,
  // [Description("Sin Programación")]
  NoSchedule = 7,
  // [Description("Capacitación")]
  Training = 8,
  MedicalLicenseApparent = 10,
}

export const attendanceTypeLabel: Record<AttendanceType, string> = {
  [AttendanceType.Absence]: 'Falta',
  [AttendanceType.Worked]: 'Laboral',
  [AttendanceType.DayOff]: 'Día Libre',
  [AttendanceType.Vacation]: 'Vacaciones',
  [AttendanceType.Permission]: 'Permiso',
  [AttendanceType.MedicalLicense]: 'Licencia Médica',
  [AttendanceType.ExtraShift]: 'Turno Extra',
  [AttendanceType.NoSchedule]: 'Sin Programación',
  [AttendanceType.Training]: 'Capacitación',
  [AttendanceType.MedicalLicenseApparent]: 'Licencia Médica Presunta',
};
